/* template */
<template><div :class='("circuit "+(goods.balance_left === 0 ? "text_light" : "")+" "+(size === "large" ? "large" : ""))' :style='(("color: " + color)+";")'><span class="circuit-site">{{goods.circuit && goods.circuit[0].starting_name}}</span><mpx-image src="https://dpubstatic.udache.com/static/dpubimg/c806d5e9-be1c-49ca-a860-656a94a3edac.png" class="circuit-img"></mpx-image><span class="circuit-site">{{goods.circuit && goods.circuit[0].dest_name}}</span></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m607a1491"}'>
.text_light {
  opacity: 0.6
}
.circuit, .circuit-site, .circuit-img
  display: inline-block
  vertical-align middle
.circuit
  min-height: 50rpx
  font-size: 22rpx
  padding: 0 12rpx
  box-sizing: border-box
  border-radius: 4rpx
  border: 1rpx solid rgba(0, 0, 0, 0.1)
  box-sizing border-box
  color: #666
  .circuit-site
    height: 50rpx
    line-height: 50rpx
    max-width: 8em
    overflow: hidden
    white-space: nowrap
    text-overflow: ellipsis
  .circuit-img
    height: 20rpx
    width: 23rpx
    margin: 0 5rpx
  &.large
    margin: 18rpx 0 0 0
    color: #333;
    box-shadow: 0 10rpx 20rpx 0 rgba(0, 0, 0, 0.05);
    border: 1px solid #EDEDED;
    border-radius: 1rpx;
    line-height: 40rpx;
    padding: 22rpx 30rpx;
    font-size: 28rpx
    .circuit-site
      max-width: 10em;
    .circuit-img
      margin: 0 8rpx
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'
createComponent({
  properties: {
    goods: {
      type: Object,
      value: function() {
        return {
          goods: {},
        }
      },
    },
    color: String,
    size: String,
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "text-circuit607a1491",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("builtInComponent.vue!=!../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?component=true"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
